import { OrderBulkDto } from '@tiendanube/common';
import { NE_PRINT_LABEL_LIMIT_TEMP } from 'domains/NuvemEnvioCommons/constants';

export const extractFulfillmentOrdersIds = (
  selectedRowsId: string[],
  bulkOrders: OrderBulkDto[],
): string[] =>
  bulkOrders
    .filter((order) => selectedRowsId.includes(order.orderId))
    .flatMap((order) =>
      order.fulfillments.map((fulfillment) => fulfillment.fulfillmentId),
    )
    .slice(0, NE_PRINT_LABEL_LIMIT_TEMP);
